import { enContent } from "../locales/en";
import type { LandingPageContent } from "../types";
import { dbkUsHomepageContent } from "./usHomepage";

export const dbkUsFooterContent: LandingPageContent["footer"] = {
  ...enContent.footer,
  summary: "AI-powered accounting agents, bookkeeping services, and connected financial workflows for U.S. businesses.",
  groups: [
    {
      id: "product",
      title: "Product",
      links: [
        { id: "software", label: "Software", href: "#software" },
        { id: "services", label: "Services", href: "#services" },
        { id: "pricing", label: "Pricing", href: "#pricing" },
        { id: "quickbooks", label: "QuickBooks", href: "/quickbooks" }
      ]
    },
    {
      id: "workflows",
      title: "Workflows",
      links: [
        { id: "accounting-agent", label: "Accounting Agent", href: "#accounting-agent" },
        { id: "data-rooms", label: "Data Rooms", href: "#data-rooms" },
        { id: "how-it-works", label: "How It Works", href: "#how-it-works" },
        { id: "workload", label: "Business workload", href: "#workload" }
      ]
    },
    {
      id: "trust",
      title: "Trust",
      links: [
        { id: "privacy", label: "Privacy", href: "https://eregis.com/privacy" },
        { id: "terms", label: "Terms", href: "https://eregis.com/terms" },
        { id: "quickbooks-terms", label: "QuickBooks terms", href: "/quickbooks/terms" },
        { id: "quickbooks-privacy", label: "QuickBooks privacy notice", href: "/quickbooks/privacy" },
        { id: "cookies", label: "Cookie settings", href: "#footer", action: "cookie-settings" },
        { id: "contact", label: "Contact", href: "/us/intake" }
      ]
    },
    {
      id: "access",
      title: "Access",
      links: [
        { id: "login", label: "Log in", href: dbkUsHomepageContent.navigation.find((item) => item.label === "Log In")!.href },
        { id: "estimate", label: "Request a service estimate", href: "/us/intake" }
      ]
    }
  ]
};
